import { gsap } from 'gsap';
function Animate(sprite, { duration = 1, speed = 1, ease = 'power3.out', type, elementToAnimate, delayValue }) {
  let animation;
  duration = duration * speed;
  let steps = elementToAnimate?.length || 1;
  if (type == 'entry') {
    animation = gsap.from(elementToAnimate, {
      duration: duration,
      pixi: {
        scale: 0,
      },
      repeat: 0,
      delay: delayValue,
      ease: 'elastic.out(1,0.3)',
      stagger: duration / steps,
    });
  } else {
    animation = gsap.to(elementToAnimate, {
      duration: duration,
      pixi: {
        scale: 0,
      },
      repeat: 0,
      delay: steps > 1 ? delayValue - duration : delayValue,
      ease: 'back.in(2)',
      stagger: duration / steps,
    });
  }
  return animation;
}
export default { Animate };
